import Constants from '../config/const';
import { loadArtfilters, loadWorksApi, loadWorkDetailsApi }  from '../config/api';

export const loadNextPage = () => (dispatch, getState) => {
  const { page, loading, activeFilters } = getState().works;
  if (loading) {
    return;
  }
  dispatch({
    type: Constants.works.load
  });
  loadWorksApi(page, activeFilters).then((works) => {
    dispatch({
      type: Constants.works.success, works
    });
  });
};

export const loadNextFavoritePage = () => (dispatch, getState) => {
  const { page, loading } = getState().favoriteWorks;
  if (loading) {
    return;
  }
  dispatch({
    type: Constants.favoriteWorks.load
  });
  loadWorksApi(page, { favorites: { value: true } }).then((data) => {
    const works = Array.isArray(data) ? data : [];
    dispatch({
      type: Constants.favoriteWorks.success, works
    });
  });
};

export const loadWorkDetails = (id) => (dispatch) => {
  dispatch({
    type: Constants.work.load,
    id
  });
  loadWorkDetailsApi(id).then((work) => dispatch({
    type: Constants.work.success,
    work
  })).catch((e) => {
    if (e.status === 404) {
      // console.log('Error loading work details', e);
    }
  });
};

export const loadArtFilters = () => (dispatch) => {
  loadArtfilters().then((filters) => dispatch({
    type: Constants.works.filtersLoaded,
    filters
  }));
};

export const addFilter = (param, value, text) => (dispatch) => {
  dispatch({
    type: Constants.works.addFilter,
    param,
    value,
    text
  });
  dispatch(loadNextPage());
};

export const removeFilter = (param) => (dispatch) => {
  dispatch({
    type: Constants.works.removeFilter,
    param
  });
  dispatch(loadNextPage());
};
